import React, { FC } from 'react';
import {
  List,
  ListProps,
  Datagrid,
  TextField,
  EmailField,
  Filter as AdminFilter,
  FilterProps,
  TextInput,
  SelectInput,
  FunctionField, DateField
} from 'react-admin'
import { makeStyles } from '@material-ui/core/styles';
import { ListActions } from '../../common/list-actions';
import { currentSeason, seasons } from '../../filters/seasonFilter';
import { couponsExporter } from '../../exporters/couponExporter';

const DEFAULT_FILTERS = {
  seasonName: currentSeason,
};

const useStyles = makeStyles({
  participantInput: {
    '& input::placeholder': {
      fontSize: '12px',
    },
  },
  bcLink: {
    marginBottom: '10px',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    padding: '10px 20px'
  }
});

const CouponFilter: FC<Omit<FilterProps, 'children'>> = (props) => {
  const classes = useStyles();

  return (
    <AdminFilter {...props}>
      <SelectInput
        label="Season name"
        optionText="id"
        source="seasonName"
        choices={seasons}
        alwaysOn
      />
      <TextInput
        label="Organization ID"
        source="midasId"
        alwaysOn
        type="number"
        inputProps={{
          inputMode: 'numeric',
          pattern: '[0-9]*',
        }}
        parse={(value: string | null) => {
          if (value == null || value === '') {
            return undefined;
          }

          if (!/^\d+$/.test(value)) {
            return undefined;
          }

          return parseInt(value, 10);
        }}
      />
      <TextInput label="Email" source="email" type="email" alwaysOn />
      <TextInput
        label="Participant"
        placeholder="E.g. code, first name or last name"
        source="participant"
        alwaysOn
        className={classes.participantInput}
      />
    </AdminFilter>
  );
};

export const CouponsList = (props: ListProps) => {
  const classes = useStyles();
  return (
    <List
      {...props}
      exporter={couponsExporter}
      actions={<ListActions />}
      empty={false}
      filterDefaultValues={DEFAULT_FILTERS}
      title="Coupons"
      filters={<CouponFilter />}
    >
      <>
        <div className={classes.bcLink}>
          Link to coupons in BigCommerce (search by promotion code using coupon code):{' '}
          <a
            href="https://store-byiy9a91j6.mybigcommerce.com/manage/marketing/promotion-manager?display=coupon"
            target="_blank"
            rel="noreferrer"
          >
            here
          </a>
        </div>
        <Datagrid isRowSelectable={() => false}>
          <TextField source="id" sortable={false} />
          <TextField
            source="registrant.seasonOrganization.organization.midasId"
            label="Organization ID"
            sortable={false}
          />
          <DateField source="createdAt" label="Sent at" />
          <TextField source="type" label="Notification type" />
          <TextField source="couponCode" label="Coupon code" />
          <EmailField
            source="registrant.user.email"
            label="Email Sent to"
            sortable={false}
          />
          <FunctionField
            label="Participants"
            render={(record: any) => {
              const participants = record?.registrant?.participants || [];
              return (
                <>
                  {participants.map(
                    (
                      {
                        firstName,
                        lastName,
                        code,
                      }: { firstName: string; lastName: string; code: string },
                      index: number
                    ) => (
                      <div key={`index${index}`}>
                        {firstName} {lastName} ({code})
                        {index < participants.length - 1 ? ',' : ''}
                      </div>
                    )
                  )}
                </>
              );
            }}
          />
        </Datagrid>
      </>
    </List>
  );
};
